import { forwardRef, type ReactElement } from 'react';

export interface ReactComponent<T> {
  props?: T;
  type?: {
    displayName?: string | null;
  } | null;
}

export type SimpleForwardRef = <T, P = object>(
  render: (props: P, ref: React.Ref<T>) => ReactElement | null
) => (props: P & React.RefAttributes<T>) => ReactElement | null;

export const simpleForwardRef = forwardRef as SimpleForwardRef;
